import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import { AppState } from 'bootstrap.store';
import { actions as personalActions } from 'components/settings/actions/personal';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

export const ConversationHeaderSidebarOpenButton = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const isCustomCardMenuOpen = useAppSelector(
    (state: AppState) => state.settings.personal.isCustomCardMenuOpen,
  );
  const shouldButtonBeVisible = useBreakpointValue({ base: true, lg: false });

  const openCustomCardMenu = () => {
    dispatch(
      personalActions.personalCustomCardMenu({
        key: 'isCustomCardMenuOpen',
        value: true,
      }),
    );
  };

  return shouldButtonBeVisible ? (
    <Tooltip content={'Show information'}>
      <IconButton
        data-testid="show-information-button"
        icon="bars"
        variant="tertiary"
        active={isCustomCardMenuOpen}
        onClick={openCustomCardMenu}
      />
    </Tooltip>
  ) : null;
};
